import React from 'react';
import { Switch, TextBox, CurrencyBox, DatePicker } from 'fw/forms';
import { SponsorLevelCombo } from 'areas/shared/controls';
import { Label } from 'fw/components';
import { Row, Col, FormGroup, MenuItem } from 'react-bootstrap';

class SponsorHistoryItem extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			sponsorHistoryId: props.value && (this.props.value.sponsorHistoryId || null),
			paypalInvoiceItemId: props.value && (this.props.value.paypalInvoiceItemId || null),
			description: props.value && (props.value.description || null),
			amount: props.value && (props.value.amount || null),
			isMembership: props.value && (props.value.isMembership || false),
			activationDate: props.value && (props.value.activationDate || null),
			expirationDate: props.value && (props.value.expirationDate || null),
			sponsorLevelId: props.value && (props.value.sponsorLevelId || null)
		};
	}

	// Public
	setValue = (value) => { this._input.setValue(value); }
	getValue = () => { return this.inputBoxValueBuilder(this._input.getValue()) }
	focus = () => { this._input.focus(); }
	select = () => { this._input.select(); }
	flag = (status) => { this._input.flag(status); }
	completed = () => { return this._input.completed(); }
	validate = () => { return this._input.validate(); }

	onDirt = (e) => {
		this.props.onDirt && this.props.onDirt(this);
	}

	listMenuItem = () => {
		return (
			this.state.types.map((item) => {
				return <MenuItem key={item} onClick={() => this.handleSelectType(item)} >{item}</MenuItem>
			})
		);
	}

	// Events

	onChange = (value) => {
		this.props.onChange && this.props.onChange(value);
	}

	handleDescriptionChange(v) {
		this.setState({ ...this.state, description: v },
			function () {
				const me = this;
				var value = this.invoiceInputValueBuilder();
				me.onChange(value);
				this.onDirt();
			}
		);
	}

	handleAmountChange(v) {
		this.setState({ ...this.state, amount: v },
			function () {
				const me = this;
				var value = this.invoiceInputValueBuilder();
				me.onChange(value);
				this.onDirt();
			}
		);
	}

	handleIsMembershipChange(v) {
		this.setState({ ...this.state, isMembership: v },
			function () {
				const me = this;
				var value = this.invoiceInputValueBuilder();
				me.onChange(value);
				this.onDirt();
			}
		);
	}

	handleActivationDateChange(v) {
		this.setState({ ...this.state, activationDate: v },
			function () {
				const me = this;
				var value = this.invoiceInputValueBuilder();
				me.onChange(value);
				this.onDirt();
			}
		);
	}

	handleExpirationDateChange(v) {
		this.setState({ ...this.state, expirationDate: v },
			function () {
				const me = this;
				var value = this.invoiceInputValueBuilder();
				me.onChange(value);
				this.onDirt();
			}
		);
	}

	handleMembershipLevelChange(comboValue) {
		this.setState({ ...this.state, sponsorLevelId: comboValue.value },
			function () {
				const me = this;
				var value = this.invoiceInputValueBuilder();
				me.onChange(value);
				this.onDirt();
			}
		);
	}

	invoiceInputValueBuilder = () => {
		return {
			sponsorHistoryId: (this.props.value && this.props.value.sponsorHistoryId) || null,
			paypalInvoiceItemId: (this.props.value && this.props.value.paypalInvoiceItemId) || null,
			description: this.state.description,
			amount: this.state.amount,
			isMembership: this.state.isMembership,
			activationDate: this.state.activationDate,
			expirationDate: this.state.expirationDate,
			sponsorLevelId: this.state.sponsorLevelId
		}
	}

	// React
	shouldComponentUpdate(nextProps, nextState) {
		return (
			nextProps.value !== this.props.value
			|| nextProps.placeholder !== this.props.placeholder
			|| nextProps.disabled !== this.props.disabled
			|| nextProps.disabledMembership !== this.props.disabledMembership
			|| nextProps.sponsorHistoryId !== this.props.sponsorHistoryId
			|| nextProps.paypalInvoiceItemId !== this.props.paypalInvoiceItemId
			|| nextState.description !== this.state.description
			|| nextState.amount !== this.state.amount
			|| nextState.isMembership !== this.state.isMembership
			|| nextState.activationDate !== this.state.activationDate
			|| nextState.expirationDate !== this.state.expirationDate
			|| nextState.sponsorLevelId !== this.state.sponsorLevelId);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.value !== this.props.value) {
			if (this.props.value) {
				this.setState({
					sponsorHistoryId: this.props.value && this.props.value.sponsorHistoryId,
					paypalInvoiceItemId: this.props.value && this.props.value.paypalInvoiceItemId,
					description: this.props.value && this.props.value.description,
					amount: this.props.value && this.props.value.amount,
					isMembership: this.props.value && this.props.value.isMembership,
					activationDate: this.props.value && this.props.value.activationDate,
					expirationDate: this.props.value && this.props.value.expirationDate,
					sponsorLevelId: this.props.value && this.props.value.sponsorLevelId,
				});
			} else {
				this.setState({
					sponsorHistoryId: null,
					paypalInvoiceItemId: null,
					description: null,
					amount: null,
					isMembership: false,
					activationDate: null,
					expirationDate: null,
					sponsorLevelId: null
				});
			}
		}
	}

	render() {
		return (
			<React.Fragment>
				<Row>
					<Col md={3}>
						<FormGroup>
							<Label required>Description</Label>
							<TextBox
								placeholder="Item Description"
								value={this.state.description}
								disabled={this.props.disabled}
								maxLength={255}
								required
								onChange={(v) => this.handleDescriptionChange(v)}
								ref={(r) => this._description = r} />
						</FormGroup>
					</Col>
					<Col md={2}>
						<FormGroup>
							<Label required>Amount</Label>
							<CurrencyBox
								positiveNumbersOnly
								value={this.state.amount}
								disabled={this.props.disabled}
								maxLength={6}
								precision={0}
								required
								onChange={(v) => this.handleAmountChange(v)}
								placeholder='Please provide whole numbers'
								ref={(r) => this._input = r} />
						</FormGroup>
					</Col>
					<Col md={2}>
						<FormGroup style={{ marginTop: "25px" }}>
							<Switch 
								disabled={this.props.disabled || (!this.state.isMembership && this.props.disabledMembership)}
								value={this.state.isMembership}
								labelLeft='Non Renewal' 
								labelRight='Renewal' 
								onChange={(v) => this.handleIsMembershipChange(v)}
								ref={(r) => this._isMembership = r}
								bsStyle='success' />
						</FormGroup>
					</Col>
					{ this.state.isMembership ?
						<React.Fragment>
							<Col md={2}>
								<FormGroup>
									<Label required>Date Paid</Label>
									<DatePicker
										placeholder='Date Paid'
										value={this.state.activationDate}
										disabled={this.props.disabled}
										required
										onChange={(v) => this.handleActivationDateChange(v)}
										ref={(r) => this._activationDate = r} />
								</FormGroup>
							</Col>
							<Col md={3}>
								<FormGroup>
									<Label required>Membership Level</Label>
									<SponsorLevelCombo 
										disabled={this.props.disabled}
										value={this.state.sponsorLevelId}
										placeholder="Membership Level"
										required
										onChange={(v) => this.handleMembershipLevelChange(v)}
										ref={(r) => this._level = r} />
								</FormGroup>
							</Col>
						</React.Fragment>
					: null }
				</Row>
			</React.Fragment>)
	}
}

export default SponsorHistoryItem;

// Mark this as a form component
SponsorHistoryItem.defaultProps = {
	formControl: true,
	managed: false,
	disabled: false,
	disabledMembership: false
};



// WEBPACK FOOTER //
// ./src/areas/shared/controls/sponsorHistoryItem/SponsorHistoryItem.js